import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DynamicHooksModule } from 'ngx-dynamic-hooks';
import { LinkComponent } from 'link';
import {
  OfferBoxButtonComponent,
  OfferBoxComponent,
  OfferBoxCountDownComponent,
  OfferStickerComponent,
} from 'offer-box';

@Component({
  selector: 'lib-offer-box-light',
  templateUrl: './offer-box-light.component.html',
  styleUrls: ['./offer-box-light.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    LinkComponent,
    NgTemplateOutlet,
    NgClass,
    NgFor,
    OfferStickerComponent,
    DynamicHooksModule,
    OfferBoxCountDownComponent,
    OfferBoxButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfferBoxLightComponent extends OfferBoxComponent {
  @Input() styleSide: 'left' | 'right' = 'left';
}
